import React from 'react';
import type { SecurityDashboardFilters as SecurityDashboardFilterValues } from '../../../models/securityDashboard';
import type { AuditCompanyOption } from './AuditFiltersPanel';

export interface SecurityDashboardFiltersProps {
  filters: SecurityDashboardFilterValues;
  companies: AuditCompanyOption[];
  onChange: (next: SecurityDashboardFilterValues) => void;
}

export function SecurityDashboardFilters({
  filters,
  companies,
  onChange,
}: SecurityDashboardFiltersProps): React.ReactElement {
  return (
    <div>
      <div className="bo-admin-toolbar bo-card">
        <label className="bo-field" htmlFor="security-dashboard-company">
          <span className="bo-field-label">Company</span>
          <select
            id="security-dashboard-company"
            className="bo-input"
            value={filters.companyId ?? ''}
            onChange={(event) => onChange({ ...filters, companyId: event.target.value || undefined })}
          >
            <option value="">All</option>
            {companies.map((company) => (
              <option key={company.companyId} value={company.companyId}>
                {company.companyName}
              </option>
            ))}
          </select>
        </label>
        <label className="bo-field" htmlFor="security-dashboard-from-date">
          <span className="bo-field-label">From</span>
          <input
            id="security-dashboard-from-date"
            type="date"
            className="bo-input"
            value={filters.fromDate ?? ''}
            onChange={(event) => onChange({ ...filters, fromDate: event.target.value || undefined })}
          />
        </label>
        <label className="bo-field" htmlFor="security-dashboard-to-date">
          <span className="bo-field-label">To</span>
          <input
            id="security-dashboard-to-date"
            type="date"
            className="bo-input"
            value={filters.toDate ?? ''}
            onChange={(event) => onChange({ ...filters, toDate: event.target.value || undefined })}
          />
        </label>
      </div>
      <p className="bo-muted">
        Defaults to the last 24 hours. Filtering by company hides events that could not be attributed to a tenant.
      </p>
    </div>
  );
}
